import { create } from 'zustand';
import { createDefaultFilterSlice, DefaultFilterState } from '../filters';
import { persist } from 'zustand/middleware';

type ShiftTemplatesFiltersState = {};
export const useShiftTemplatesFiltersStore = create<DefaultFilterState & ShiftTemplatesFiltersState>()(
  persist(
    (set, ...a) => ({
      ...createDefaultFilterSlice(set, ...a),
    }),
    {
      name: 'userdata:shiftTemplates',
    },
  ),
);
